<div class="card">
  <div class="card-body row p-3">
    <h5 class="font-size-14" *ngIf="claimLimit; else noLimit">
      YOU HAVE <span class="benefits-header-claimed mx-2">{{ numberClaimed }}/{{ claimLimit }}</span> CHOICE BENEFITS
    </h5>
    <ng-template #noLimit><h4 class="font-size-14">YOU HAVE UNLIMITED CHOICE BENEFITS</h4></ng-template>
    <p class="mb-0 benefits-header-description font-size-12">
      As a big member, we are providing you with the opportunity to customize your membership!
    </p>
    <p class="mb-0 benefits-header-description font-size-12">Choose your benefits from the list below</p>
  </div>
</div>
